import { render, staticRenderFns } from "./templateSayhiOne.vue?vue&type=template&id=7bae9919&scoped=true"
import script from "./templateSayhiOne.vue?vue&type=script&lang=js"
export * from "./templateSayhiOne.vue?vue&type=script&lang=js"
import style0 from "./templateSayhiOne.vue?vue&type=style&index=0&id=7bae9919&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bae9919",
  null
  
)

export default component.exports